<dashboardnav>
  
    <cradua-lorp
        [lorps]="lorps$ | async"
        (lorp)="onSubmitLorp($event)"
        (deleteLorpEvent)="onDeleteLorp($event)"
        *ngIf="(isLoadingLorp$ | async ) === false"
        >
  </cradua-lorp>
  
    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoadingLorp$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
  